import {
  API_STATES
} from '@/helpers'

const state = {
  permissionsGetState         : API_STATES.NOT_REQUESTED,
  permissionsGetError         : null,
  assignedPermissionsGetState : API_STATES.NOT_REQUESTED,
  assignedPermissionsGetError : null,
  assignedPermissions         : [],
  permissions                 : [],
  permissionsCreateState      : API_STATES.NOT_REQUESTED,
  permissionsCreateError      : null,
  permissionsDeleteState      : API_STATES.NOT_REQUESTED,
  permissionsDeleteError      : null
}

export default state
